"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginAdmin = exports.deleteCookie = exports.setCookie = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../common");
const server_1 = require("../../../../server");
const LoginStyled = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	background: var(--color-tur, #3ab2bf);
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: auto;

	> * {
		box-sizing: border-box;
	}

	.login_line {
		display: flex;
		gap: 12px;
		align-items: center;
		justify-content: center;
		width: 100%;

		.login_title {
			width: 95px;
			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--h4-font-size, 20px);
			line-height: var(--h4-line-height, 32px);
			font-weight: var(--h4-font-weight, 700);
			position: relative;
		}

		input {
			padding: 12px;
			flex: 1;
		}
	}

	.login_box {
		position: relative;
		overflow: auto;
		padding: 42px;
		box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
		border-radius: 10px;
		margin: 0 auto;
		background: var(--color-white, #ffffff);
		display: flex;
		flex-direction: column;
		gap: 24px;
		justify-content: flex-start;
		align-items: center;
		justify-content: flex-start;
		overflow: auto;
	}

	.login_wrap {
		display: flex;
		flex-direction: column;
		gap: 24px;
		width: 450px;

		form {
			display: flex;
			flex-direction: column;
			gap: 28px;
			width: 100%;
		}
		.dropdown {
			flex: 1;

			.dropdown-field {
				border: 1px solid var(--color-gray-3, #e5e5e5);
				border-radius: 10px;
				padding: 12px 24px;
			}
		}

		input {
			padding: 15px 24px;
			border: 1px solid var(--color-gray-3, #e5e5e5);
			border-radius: 10px;
			box-sizing: border-box;
		}
	}
`;
function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}
exports.setCookie = setCookie;
function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
exports.deleteCookie = deleteCookie;
exports.LoginAdmin = react_1.default.memo(() => {
    const [authName, setAuthName] = react_1.default.useState('');
    const [password, setPassword] = react_1.default.useState('');
    // const loginMutation = useMutation(postLogin);
    const onLogin = async () => {
        try {
            if (authName.trim() === '' || password.trim() === '') {
                alert('아이디와 비밀번호를 입력하세요.');
                return;
            }
            const response = await (0, server_1.postLogin)({
                partner_id: 'default',
                auth_name: authName,
                auth_password: password,
            });
            const result = response.result;
            if (result) {
                const token = {
                    access_token: result.access_token,
                    refresh_token: result.refresh_token,
                };
                const verifyResponse = await (0, server_1.postVerifyToken)({
                    access_token: result.access_token,
                });
                const user = verifyResponse.result.user;
                const isAdmin = user.role_name === 'admin';
                const isAcademy = user.role_name === 'academy';
                if (!isAdmin && !isAcademy) {
                    alert('관리자 계정으로 로그인 해주세요.');
                    return;
                }
                token.refresh_token && setCookie('refresh_token', token.refresh_token, 1);
                const popupUrl = `/admin-page`;
                const popupName = 'Test';
                const popupFeatures = 'popup=true, width=1920, height=1024, scrollbars=no';
                // Open the popup window
                const popupWindow = window.open(popupUrl, popupName, popupFeatures);
                // Focus on the popup window (optional)
                if (popupWindow) {
                    popupWindow.focus();
                    popupWindow.onload = function () {
                        // Remove an item from localStorage in the popup window
                        popupWindow.localStorage.clear();
                    };
                }
            }
        }
        catch (error) {
            alert(error);
        }
    };
    return (react_1.default.createElement(LoginStyled, null,
        react_1.default.createElement("div", { className: "login_box" },
            react_1.default.createElement(common_1.Icon, { icon: "logo", width: 90, height: 40 }),
            react_1.default.createElement("div", { className: "login_wrap" },
                react_1.default.createElement("form", { onSubmit: e => e.preventDefault() },
                    react_1.default.createElement("div", { className: "login_line" },
                        react_1.default.createElement("div", { className: "login_title" }, "\uC544\uC774\uB514"),
                        react_1.default.createElement(common_1.InputElement, { type: "text", isEnterPrevent: true, placeholder: "\uC544\uC774\uB514", onChange: setAuthName, onSubmit: onLogin })),
                    react_1.default.createElement("div", { className: "login_line" },
                        react_1.default.createElement("div", { className: "login_title" }, "\uBE44\uBC00\uBC88\uD638"),
                        react_1.default.createElement(common_1.InputElement, { placeholder: "\uBE44\uBC00\uBC88\uD638", isEnterPrevent: true, type: "password", onChange: setPassword, onSubmit: onLogin })))),
            react_1.default.createElement(common_1.Button, { className: "btn_default xmd", text: "\uB85C\uADF8\uC778", onClick: onLogin }))));
});
